import styled from 'styled-components';

// 表单容器样式
export const ChatFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  width: 100%;
  padding: 70px 15px 15px 15px;
  box-sizing: border-box;
  height: 100%;
  overflow-y: scroll;

  img {
    width: 70px;
    height: 70px;
  }
`;

export const ChatFormWrapper = styled.form`
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SubmitButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  margin-top: 40px;
  margin-bottom: 50px;
  width: 160px;
  height: 40px;
  background-color: ${(props) => props.$themecolor ?? '#3F5773'};
  outline: none;
  font-weight: bold;
  border-radius: 4px;
  padding: 10px;
  box-sizing: border-box;
  color: #ffffff;
  transition: ease all 250ms;
  border: unset;
  cursor: pointer;
`;
